import { Box, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BusinessContext } from "../../context/businessContext";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { GlobalContext } from "../../context/globalContext";
import { fakeTableList, headTitleList } from "./parts";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import "./_style.scss";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import {
  ITkViewButtonJudgementflowType,
  ITkViewButtonJudgementStatus,
} from "../../type/componentsType/TkViewButtonJudgement";
import { TkGetCode, TkGetCodeList } from "../../utils/TkGetCode";
import {
  applyEvent,
  BenefitsKbn,
  CommonOrCommonRetirementFlug,
  FormClassApply,
  formClassCorp,
  InquiryCode,
} from "../../assets/data/Constants";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { httpAPI_APP016, httpAPI_CON005 } from "./api/request";
import TkLabelText from "../../components/atoms/TkLabelText";
import { TkRadioGroup } from "../../components/atoms/TkRadioGroup";
import TkTextArea from "../../components/molecules/TkTextArea";
import TkDialog from "../../components/atoms/TkDialog";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import _ from "lodash";
import { isStatusAfterApproval } from "../../utils/useTools";

/**
 * SCRW040002 「俸給の調整額」新規申請
 * このコンポーネントは、fakeTableListとheadTitleListをレンダリングします。
 * @return SCRW040002 「俸給の調整額」新規申請
 */

const SCRW040002 = () => {
  const navigate = useNavigate();
  let location = useLocation();
  const locationState = location.state;
  const { state: businessState } = useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const [tableList, setTableList] = useState<any>([]);
  const [fileList, setFileList] = useState<any[]>([
    [{ children: "" }, { children: "" }, { children: "" }],
  ]);
  const [status, setStatus] = useState<ITkViewButtonJudgementStatus>();
  const [logList, setLogList] = useState<any[]>([]);
  const [memo, setMemo] = useState<string>("");
  const [check, setCheck] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [applyFlow, setApplyFlow] =
    useState<ITkViewButtonJudgementflowType>("TYPE1");
  const [businessType, setBusinessType] = useState("");
  const [opReason, setOpReason] = useState<boolean>(false);
  const [reasonText, setReasonText] = useState<string>("");

  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  async function openingScreen() {
    try {
      //「俸給の調整額」対象手当参照API実行
      const res = await httpAPI_CON005({
        applyId: locationState?.applyId,
        contractorNo: businessState.common?.contractorNo,
        allowanceSerialNo: locationState?.allowanceSerialNo,
      });

      if (res.resultCd === "I0000") {
        const log = [];
        if (res.statusList) {
          for (let i in res.statusList) {
            const date = new Date(res.statusList[i].createDate!);
            const data = [
              {
                children: res.statusList[i].managerName,
                align: "center",
              },
              {
                children: res.statusList[i].process,
                align: "center",
              },
              {
                children:
                  date.getFullYear() +
                  "/" +
                  (date.getMonth() + 1) +
                  "/" +
                  date.getDate(),
                align: "center",
              },
              {
                children: res.statusList[i].processComment,
                align: "center",
              },
            ];
            log.push(data);
          }
        }
        setLogList(log);
        let allowanceKbnList = "";
        res.approvedAllowanceList?.forEach((item) => {
          if (allowanceKbnList.length === 0) {
            allowanceKbnList = item.approvedAllowanceKbnExtras ?? "";
          } else {
            allowanceKbnList =
              allowanceKbnList + "、" + item.approvedAllowanceKbnExtras;
          }
        });

        let resArr = stateFakeTableList.current;
        resArr.find((item) => item.keyword === "applyBenefitsName")!.node = (
          <Box className="tkRadio">
            <TkRadioGroup
              radioPropsList={TkGetCodeList(BenefitsKbn)}
              wantToSetValue={res.allowanceKbn}
              disabled={true}
            />
            <Box>
              {res.allowanceKbn === "3" && (
                <TkLabelText
                  wantToSetValue={res.allowanceKbnExtras}
                  disabled={true}
                />
              )}
            </Box>
          </Box>
        );
        resArr.find((item) => item.keyword === "benefitsList")!.text =
          allowanceKbnList;
        resArr.find(
          (item) => item.keyword === "parallelRule"
        )!.setDefaultValue = res.salaryRegulations;

        resArr.find(
          (item) => item.keyword === "minAndMaxAmt"
        )!.setDefaultValue = {
          max: res.maxAmt,
          min: res.minAmt,
        };

        resArr.find((item) => item.keyword === "article")!.setDefaultValue =
          res.salaryText;
        const formList = res.formList?.find(
          (item) => item.formClass === formClassCorp["給与規程"]
        );
        let salaryRules = resArr.find(
          (item) => item.keyword === "salaryRules"
        )!;

        if (formList) {
          salaryRules.dataname = formList?.fileName!;
          salaryRules.base64filedata = formList?.fileBase64!;
        }

        const facilityList = [];
        const checkedList = [];
        if (res.facilityList) {
          for (let i in res.facilityList) {
            const data = {
              label:
                (res.facilityList[i].facilityNo ?? "") +
                ":" +
                (res.facilityList[i].facilityName ?? ""),
              disabled: true,
            };
            if (res.facilityList[i].facilityFlg === "1") {
              checkedList.push(data.label);
            }
            facilityList.push(data);
          }
        }

        resArr.find(
          (item) => item.keyword === "targetFacilities"
        )!.checkBoxList = facilityList;

        resArr.find(
          (item) => item.keyword === "targetFacilities"
        )!.setDefaultValue = checkedList;
        resArr.find((item) => item.keyword === "checkBox1")!.setDefaultValue = [
          `${res.basicItem1 === "1" ? "はい、表記があります" : ""}`,
        ];
        resArr.find((item) => item.keyword === "checkBox2")!.setDefaultValue = [
          `${res.basicItem2 === "1" ? "はい、表記があります" : ""}`,
        ];
        resArr.find((item) => item.keyword === "checkBox3")!.setDefaultValue = [
          `${res.basicItem3 === "1" ? "はい、表記があります" : ""}`,
        ];
        resArr.find((item) => item.keyword === "checkBox4")!.setDefaultValue = [
          `${res.basicItem4 === "1" ? "はい、表記があります" : ""}`,
        ];

        resArr.find((item) => item.keyword === "title6")!.showLine =
          res.latestApplyStatus === "05"
            ? true
            : res.latestApplyStatus === "07"
            ? true
            : res.latestApplyStatus === "09"
            ? true
            : res.latestApplyStatus === "13"
            ? true
            : res.latestApplyStatus === "14"
            ? true
            : false;
        resArr.find((item) => item.keyword === "notApplicableReason")!.text =
          res.notApplicableReason;
        resArr.find(
          (item) => item.keyword === "notApplicableReason"
        )!.showLine =
          res.latestApplyStatus === "05"
            ? true
            : res.latestApplyStatus === "07"
            ? true
            : res.latestApplyStatus === "09"
            ? true
            : res.latestApplyStatus === "13"
            ? true
            : res.latestApplyStatus === "14"
            ? true
            : false;
        setTableList([...resArr]);

        const downloadFile = res.formList?.find(
          (item) => item.formClass === "EXP0601020"
        );
        let showFlg = isStatusAfterApproval(res.latestApplyStatus);
        let logMakeList = [
          [
            {
              children: downloadFile ? (
                <TkDownloadLink
                  downloadBase64={true}
                  dataname={TkGetCode(FormClassApply, downloadFile?.formClass)}
                  base64filedata={downloadFile?.fileBase64 ?? ""}
                />
              ) : (
                <></>
              ),
            },
            {
              children: showFlg ? res.symbolNo : "",
            },
            {
              children: showFlg ? res.decisionDate : "",
            },
          ],
        ];
        setFileList(logMakeList);

        res.latestApplyStatus &&
          setStatus(res.latestApplyStatus as ITkViewButtonJudgementStatus);
        res.allowanceKbn === "1" || res.allowanceKbn === "2"
          ? setApplyFlow("TYPE4")
          : setApplyFlow("TYPE1");
        res.allowanceKbn === "1" || res.allowanceKbn === "2"
          ? setBusinessType("JOB-08")
          : setBusinessType("JOB-07");
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }
  useEffect(() => {
    openingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const inputChange = (value: any) => {
    value.target.type === "checkbox"
      ? setCheck(value.target.value)
      : setMemo(value.target.value);
  };

  const clickJudge = async (btnName: keyof typeof applyEvent) => {
    let event = applyEvent[btnName];

    switch (event) {
      case applyEvent["受理"]:
      case applyEvent["契約者に差戻し"]:
      case applyEvent["上長承認"]:
      case applyEvent["上長拒絶承認"]:
      case applyEvent["担当者に差戻し"]:
      case applyEvent["通知"]:
      case applyEvent["郵送"]:
      case applyEvent["課長代理確認"]:
      case applyEvent["課長代理拒絶確認"]:
        updateStatus(event);
        break;
      case applyEvent["承認"]:
        setOpen(true);
        break;
      case applyEvent["拒絶"]:
        setOpReason(true);
        break;
    }
  };

  const updateStatus = async (status: string, data?: any) => {
    try {
      const res = await httpAPI_APP016({
        applyId: locationState?.applyId,
        applyEvent: status,
        contractorNo: businessState.common?.contractorNo,
        reason: memo,
        inquiryCode: check ? InquiryCode["契約者"] : "",
        screenId: "SCRW040002",
        notApplicableReason: status === "4" ? reasonText : "",
        ...(status === applyEvent["承認"] && {
          decisionDate: data.settlementDate,
          symbolNo:
            TkGetCode(CommonOrCommonRetirementFlug, data.symbolNumberType) +
            "第" +
            (data.symbolNumber ?? "") +
            "号",
        }),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const saveReason = (data: any) => {
    setReasonText(data);
  };

  return (
    <Box data-testid="SCRW040002PageForTest" className="tkSCRW040002">
      <TkKikoStepper
        applicationFlowType={applyFlow}
        businessType={businessType}
        applicationStatus={status}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW040002_01}</TkInfoManual>
      <TkContractorAndNumberLine
        no={
          (businessState.common?.contractorNo ?? "") +
          ":" +
          (businessState.common?.contractorName ?? "")
        }
        name="契約者（法人）名"
      />

      <TkFakeTable list={tableList} ruleSchema={{}} showButton={false} />

      <TkMemo bodyList={logList} showTable={true} onChange={inputChange} />
      <TkTableWithNoLine headList={headTitleList} bodyList={fileList} />
      <Box className="buttonGroup">
        <TkBackButton mr />
        <TkViewButtonJudgement
          flowType={applyFlow}
          Status={status as ITkViewButtonJudgementStatus}
          onClick={clickJudge}
        />
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        open={open}
        onClose={closeDialog}
        onSuccess={(e: any) => updateStatus(applyEvent["承認"], e)}
      />
      <TkDialog
        open={opReason}
        onCancel={() => setOpReason(false)}
        title="拒絶"
        okText="登録"
        cancelText="戻る"
        onSave={() => {
          if (reasonText.length === 0) {
            setState({
              ...state,
              errorMsgId: "TKMSG_SCR0043E",
            });
          } else if (
            // eslint-disable-next-line no-control-regex
            !reasonText.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/)
          ) {
            setState({
              ...state,
              errorMsgId: "TKMSG_SCR0061E",
            });
          } else if (reasonText.length > 200) {
            setState({
              ...state,
              errorMsgId: "TKMSG_SCR0098E",
            });
          } else {
            setOpReason(false);
            updateStatus("4");
          }
        }}
      >
        <Typography>非該当理由を入力してください。</Typography>
        <TkTextArea
          onChange={(e) => {
            saveReason(e.target.value);
          }}
        />
      </TkDialog>
    </Box>
  );
};

export default SCRW040002;
